import React from "react";
import { motion } from "framer-motion";
import ReviewsCarousel from "../components/ReviewsCarousel";
import { ProductSection } from "../components/ProductSection";

const Shop = () => {
  return (
    <div className="bg-yellow-50 pt-20 min-h-screen">
      <ProductSection />

      {/* About Us Section with Benefits */}
      <section className="bg-[#a41e24] relative py-12 md:py-16 overflow-hidden">
        {/* Background shapes */}
        <div
          className="absolute top-0 right-0 w-full md:w-[55%] h-full bg-yellow-500 hidden lg:block"
          style={{
            clipPath: "polygon(100% 0, 0 0, 100% 100%)",
          }}
        />
        <div className="absolute top-0 right-0 w-full h-full bg-yellow-500 opacity-10 sm:hidden" />

        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center"
          >
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="space-y-6"
            >
              <p
                className="text-white text-lg sm:text-xl md:text-2xl text-center lg:text-left "
                style={{
                  fontFamily: "Veneer, sans-serif",
                }}
              >
                <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
                  Unleash Your Inner Titan:
                </span>
                <br />
                Zinc isn't just for immunity; it's a key player in testosterone
                production, promoting muscle growth, strength, and making you
                feel like Hercules at the gym. Elevate your physical prowess
                today!{" "}
                <sup
                  style={{
                    top: "-1em",
                    fontSize: "50%",
                  }}
                >
                  †
                </sup>
                <br /> <br />{" "}
                <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
                  Revitalize Your Inner Spark:{" "}
                </span>
                <br />
                With Tribulus terrestris and Tongkat Ali, your confidence gets a
                natural boost, enhancing your vitality and zest for life.
                Experience an invigorating lift in your overall energy and
                allure.
                <sup
                  style={{
                    top: "-1em",
                    fontSize: "50%",
                  }}
                >
                  †
                </sup>
                <br />
                <br />
                <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
                  Stamina Surge:
                </span>
                <br />
                Ashwagandha, Horny Goat Weed and Hawthorne extract combine
                forces to provide not only an energy boost but also stress
                relief, transforming your endurance and ensuring you're ready
                for any challenge, whether it's a marathon or a marathon session
                at work.
                <sup
                  style={{
                    top: "-1em",
                    fontSize: "50%",
                  }}
                >
                  †
                </sup>
                <br />
                <br />
                <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
                  Metabolic Mastery:
                </span>
                <br />
                Dive into the benefits of DIM,Siberian Ginseng and Cordyceps
                sinensis,which help in balancing hormones for optimal
                testosterone levels, enhancing your metabolism for lean muscle
                growth, and keeping you sharp and vibrant throughout your day.
                <sup
                  style={{
                    top: "-1em",
                    fontSize: "50%",
                  }}
                >
                  †
                </sup>
                <br />
                <br />
                <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
                  Quality Beyond Compare:
                </span>
                <br />
                We're not just about boosting your testosterone; we're about
                doing it right. Our supplements are GMP compliant, undergo
                rigorous 3rd party lab testing, and are made from non-GMO
                ingredients, ensuring purity, potency, and trust in every serv
                <sup
                  style={{
                    top: "-1em",
                    fontSize: "50%",
                  }}
                >
                  †
                </sup>
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="relative mt-8 lg:mt-0"
            >
              {/* Desktop Bull Image */}
              <div className="max-w-md hidden lg:block md:max-w-none">
                <img
                  src="/media/bull.png"
                  alt="About ZivBioLabs"
                  className="w-3/6 h-auto relative bottom-9 left-1/4"
                />
              </div>

              {/* Mobile Bull Image - visible on mobile, hidden on lg screens */}
              <div className="flex justify-center lg:hidden mb-8">
                <img
                  src="/media/bull.png"
                  alt="About ZivBioLabs"
                  className="w-3/4  h-auto"
                />
              </div>

              {/* Benefits List */}
              <div className="flex justify-center md:justify-center gap-6 pl-0 md:pl-20 md:gap-8 lg:gap-16">
                <div className="text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-16 md:h-16 lg:w-20 lg:h-20 flex items-center justify-center mb-3">
                    <img
                      src="/media/icon_cirlce_man-muscle.svg"
                      alt="Muscle"
                      className="w-full h-full"
                    />
                  </div>
                  <p
                    className="text-white text-xl sm:text-xl md:text-2xl lg:text-3xl"
                    style={{
                      fontFamily: "Veneer, sans-serif",
                    }}
                  >
                    MUSCLE
                    <br />
                    GROWTH
                    <sup
                      style={{
                        top: "-1em",
                        fontSize: "50%",
                      }}
                    >
                      †
                    </sup>
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-16 md:h-16 lg:w-20 lg:h-20 flex items-center justify-center mb-3">
                    <img
                      src="/media/icon_cirlce_spark.svg"
                      alt="Energy"
                      className="w-full h-full"
                    />
                  </div>
                  <p
                    className="text-white text-xl sm:text-xl md:text-2xl lg:text-3xl"
                    style={{
                      fontFamily: "Veneer, sans-serif",
                    }}
                  >
                    ENERGY
                    <br />
                    LEVELS
                    <sup
                      style={{
                        top: "-1em",
                        fontSize: "50%",
                      }}
                    >
                      †
                    </sup>
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-16 md:h-16 lg:w-20 lg:h-20 flex items-center justify-center mb-3">
                    <img
                      src="/media/icon_cirlce_male-symbol.svg"
                      alt="Libido"
                      className="w-full h-full"
                    />
                  </div>
                  <p
                    className="text-white text-xl sm:text-xl md:text-2xl lg:text-3xl"
                    style={{
                      fontFamily: "Veneer, sans-serif",
                    }}
                  >
                    LIBIDO &
                    <br />
                    STAMINA
                    <sup
                      style={{
                        top: "-1em",
                        fontSize: "50%",
                      }}
                    >
                      †
                    </sup>
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <ReviewsCarousel />
      <div className=" pt-24" />

      {/* Guarantee Section */}
      {/* <section className="bg-yellow-50 py-8 sm:py-12 md:py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <h2
              className="text-xl md:text-3xl lg:text-5xl font-bold text-center mb-4 sm:mb-6 md:mb-8 tracking-widest text-[#a41e24]"
              style={{
                fontFamily: "Veneer, sans-serif",
                textShadow:
                  "0.1vw 0 0 white, 0.2vw 0 0 white, 0.1vw 0.1vw 0 white, 0.2vw 0.2vw 0 white",
              }}
            >
              OUR SATISFACTION GUARANTEE
            </h2>
            <p className="text-gray-600 text-base sm:text-lg md:text-xl mb-6 sm:mb-8">
              Try ZivBioLabs Testosterone Booster risk-free with our 30-day
              money-back guarantee. If you're not completely satisfied, we'll
              refund your purchase - no questions asked.
            </p>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="mt-6 sm:mt-8"
            >
              <button
                type="button"
                className="bg-gradient-primary text-white px-8 sm:px-10 md:px-12 py-3 sm:py-4 rounded-lg font-bold text-base sm:text-lg md:text-xl hover:opacity-90 transition-opacity inline-flex items-center justify-center"
              >
                Learn More About Our Guarantee
              </button>
            </motion.div>
          </motion.div>
        </div>
      </section> */}
    </div>
  );
};

export default Shop;
